var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", flat: "", color: "primary", dark: "" } },
            [_c("v-toolbar-title", [_vm._v("Receipt Attachments")])],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.errors.amount,
                          dense: "",
                          outlined: "",
                          label: "Amount"
                        },
                        model: {
                          value: _vm.form.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "amount", $$v)
                          },
                          expression: "form.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "5" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.errors.notes,
                          dense: "",
                          outlined: "",
                          label: "Notes"
                        },
                        model: {
                          value: _vm.form.notes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "notes", $$v)
                          },
                          expression: "form.notes"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-file-input", {
                        attrs: {
                          "error-messages": _vm.errors.image,
                          dense: "",
                          outlined: "",
                          label: "Image",
                          accept: "image/*"
                        },
                        model: {
                          value: _vm.form.image,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "image", $$v)
                          },
                          expression: "form.image"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            color: "green",
                            outlined: "",
                            loading: _vm.loadingSubmit
                          },
                          on: { click: _vm.submit }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.form.id ? "Update" : "Add") + " "
                          )
                        ]
                      ),
                      _vm.form.id
                        ? _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              on: { click: _vm.resetForm }
                            },
                            [_vm._v(" Cancel ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4" }),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.data,
                  loading: _vm.loading,
                  dense: "",
                  "disable-pagination": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.image",
                    fn: function({ item }) {
                      return [
                        _c("img", {
                          staticStyle: {
                            "object-fit": "cover",
                            "border-radius": "4px",
                            cursor: "pointer"
                          },
                          attrs: {
                            src: item.image_url_avatar,
                            width: "60",
                            height: "60"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showImage(item)
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.edit(item)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "yellow darken-3" } },
                              [_vm._v("mdi-pencil")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "", color: "red" },
                            on: {
                              click: function($event) {
                                return _vm.remove(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "", flat: "" } },
                    [
                      _c("v-toolbar-title", [_vm._v("Image Preview")]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-card-text", { staticClass: "text-center" }, [
                    _vm.dialogData?.image_url_full
                      ? _c("img", {
                          staticStyle: {
                            "max-width": "100%",
                            "max-height": "70vh",
                            "object-fit": "contain"
                          },
                          attrs: { src: _vm.dialogData?.image_url_full }
                        })
                      : _vm._e(),
                    _vm.dialogData?.notes
                      ? _c(
                          "div",
                          { staticClass: "mt-4 text-left" },
                          [
                            _c("v-divider", { staticClass: "mb-2" }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-subtitle-2 font-weight-bold mb-1"
                              },
                              [_vm._v("Notes")]
                            ),
                            _c("div", { staticClass: "text-body-2" }, [
                              _vm._v(_vm._s(_vm.dialogData.notes))
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }